import React, { useCallback, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { doLogout, lockUserAccount } from 'actions/authActions'
import { useSelector, useDispatch } from 'react-redux'
import Waiting from './Waiting.jsx'
import debug from 'Helper/debugHelpers'

const LockAccount = ({
  setStateMessageRef
}) => {
  const dispatch = useDispatch()
  const [message, setMessage] = useState()
  const [error, setError] = useState()
  const [waiting, setWaiting] = useState()
  const { token, refreshToken } = useSelector(state => state.auth)
  const onLockAcccountClick = useCallback(() => {
    const callbacks = {
      200: () => {
        setMessage('Your account has been successfully locked. Please contact your system administrator to regain access.')
        setWaiting(false)
        if (token || refreshToken) {
          // only try to logout if we are logged in.
          debug.log('doing logout after account lock.',debug.logLevels.AUTH)
          dispatch(doLogout())
        }
      },
      error: () => {
        setError('Unable to lock account. Please contact your system administrator.')
      }
    }
    setWaiting(true)
    dispatch(lockUserAccount(null, callbacks))
  }, [token, refreshToken])

  if (waiting) {
    return <Waiting message="Account lock in progress..."/>
  } else if (!message && !error) {
    return <DoLock onLockAcccountClick={onLockAcccountClick}/>
  } else {
    return <AccountLocked message={message} error={error} />
  }
}

export default LockAccount

const DoLock = ({ onLockAcccountClick }) => {
  return (
    <div className="recovery-content">
      <div className="alert alert-danger" role="alert" data-cy="alert">
        <FontAwesomeIcon icon={['fas', 'exclamation-triangle']} size="1x" />
        {'Lock user account?'}
      </div>
      <div className="login-text">
        If there is a chance that somone other than you has gained access to
        your account and you are unable to login and change your password, you
        can use the lock button below to lock your account. This will make your
        account unusable by anyone until a system administrator is able to
        verify your identity and reset your login credentials and email.
      </div>
      <div className="recovery-buttons">
        <button
          aria-label="Lock account button"
          className="btn btn-default"
          onClick={onLockAcccountClick}
        >
          Lock account
        </button>
      </div>
    </div>
  )
}

const AccountLocked = ({ message, error }) => {
  return (
    <div className="recovery-content">
      {
        error
          ? <div className="alert alert-danger" role="alert" data-cy="alert">
            <FontAwesomeIcon icon={['fas', 'exclamation-triangle']} size="1x" />
            {'Lock user account?'}
          </div>
          : null
      }
      {
        message
          ? <div className="login-text">
            {message}
          </div>
          : null
      }
    </div>
  )
}
